import { Link } from "react-router-dom";
import { Reveal } from "@/components/motion/Reveal";
import { posts } from "@/data/journal";
import EarlyAccessForm from "@/components/EarlyAccessForm";

export default function Journal() {
  return (
    <div data-testid="journal-page">
      <section data-testid="journal-hero" className="bg-ivory">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 pt-32 md:pt-48 pb-16">
          <p className="eyebrow eyebrow-brass mb-6">Journal</p>
          <h1 className="font-display leading-[1.14]" style={{ fontSize: "clamp(64px, 12vw, 180px)", fontWeight: 300 }}>
            Letters from the <em className="italic">house.</em>
          </h1>
          <p className="mt-10 max-w-2xl text-[16px] leading-[1.8] text-pencil">
            Notes from a house still being built — ingredients we're testing, the formula finding its feet,
            the small gaps we're closing next. No noise, only what's worth writing down.
          </p>
        </div>
      </section>

      <section data-testid="journal-list" className="bg-ivory">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-16 md:py-24 border-t border-sage">
          <div className="grid gap-16 md:gap-20">
            {posts.map((p, i) => (
              <Reveal key={p.slug} delay={i * 0.06}>
                <Link
                  to={`/journal/${p.slug}`}
                  data-testid={`journal-card-${p.slug}`}
                  className="group grid md:grid-cols-12 gap-6 md:gap-10 border-t border-sage pt-10 md:pt-14"
                >
                  <div className="md:col-span-2">
                    <p className="font-mono-stamp text-brass">{p.number}</p>
                    <p className="font-mono-stamp text-pencil mt-2">{p.date}</p>
                  </div>
                  <div className="md:col-span-6">
                    <h2 className="font-display text-4xl md:text-6xl leading-[1.14]" style={{ fontWeight: 300 }}>
                      {p.title}
                    </h2>
                    <p className="mt-4 text-pencil text-[15px] max-w-xl">{p.dek}</p>
                    <p className="mt-6 btn-ghost inline-flex">Read the letter →</p>
                  </div>
                  <div className="md:col-span-4">
                    <div className="overflow-hidden border border-sage">
                      <img
                        src={p.hero + "?w=900&q=80"}
                        alt={p.title}
                        className="w-full h-[280px] md:h-[320px] object-cover transition-transform duration-[1400ms] group-hover:scale-105"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Follow-the-work join section removed */}
    </div>
  );
}
